<script>
export default {
  props: {
    height: {
      type: String,
      required: false,
      default: '128',
    },
    width: {
      type: String,
      required: false,
      default: '128',
    },
    fill: {
      type: String,
      required: false,
      default: '#497699',
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: true,
    },
  },
};

</script>

<template>
  <svg
    v-if="type === 'blocks'"
    :class="className"
    :height="height"
    :width="width"
    viewBox="0 0 128 128"
  >
    <path :fill="fill" d="M0.024 45.418H39.62V77.219H0.024z"/>
    <path :fill="fill" d="M44.316 45.418H83.912V77.219H44.316z"/>
    <path :fill="fill" d="M88.404 45.418H128V77.219H88.404z"/>
    <path fill="#78909c" d="M4.403 54.87H35.19V68.536H4.403z"/>
    <path fill="#78909c" d="M49.192 54.87H79.979V68.536H49.192z"/>
    <path
      fill="#78909c"
      d="M93.025 54.87H123.81200000000001V68.536H93.025z"
    />
  </svg>
  <svg
    v-if="type === 'button'"
    :class="className"
    :height="height"
    :width="width"
    viewBox="0 0 128 128"
  >
    <path
      :fill="fill"
      :d="
        'M9.839 31.902c-5.67 0-10.275 3.985-10.275 '
        +'8.891v40.011c0 4.904 4.605 8.89 10.275 '
        +'8.89h107.886c5.67 0 10.275-3.986 '
        +'10.275-8.89V40.793c0-4.906-4.605-8.891-10.275-8.891zm75.836 '
        +'22.913c4.357 0 7.126 2.529 7.126 6.599 0 4.082-2.769 '
        +'6.608-7.126 6.608-4.374 0-7.144-2.526-7.144-6.608 0-4.07 '
        +'2.8-6.599 7.144-6.599zm-68.35.35h6.753c2.89 0 4.584 1.17 '
        +'4.584 3.116 0 1.344-1.153 2.481-2.69 2.664v.165c1.889.086 '
        +'3.364 1.365 3.364 2.96 0 2.2-1.968 3.613-5.069 3.613h-6.942zm15.673 '
        +'0h3.682v7.857c0 1.457.925 2.327 2.558 2.327 1.637 0 2.551-.87 '
        +'2.551-2.327v-7.857h3.681v8.194c0 2.814-2.469 4.663-6.232 '
        +'4.663-3.763 0-6.24-1.849-6.24-4.663zm16.135 '
        +'0h12.028v2.551h-4.192v9.967h-3.662v-9.967h-4.174zm14.88 '
        +'0h12.029v2.551h-4.181v9.967h-3.674v-9.967h-4.174zm32.551 '
        +'0h2.939l6.031 7.047h.19v-7.047h3.493v12.518h-2.92l-6.052-7.'
        +'121h-.19v7.121h-3.491zm-75.556 2.237v2.858h1.943c1.347 '
        +'0 2.13-.54 2.13-1.424 0-.895-.734-1.434-1.987-1.434zm64.667.053c-2.037 '
        +'0-3.391 1.546-3.391 3.959 0 2.424 1.337 3.968 3.391 3.968 2.038 '
        +'0 3.383-1.544 3.383-3.968 0-2.413-1.353-3.959-3.383-3.959zm-64.667 '
        +'4.742v3.247h2.227c1.526 0 2.358-.591 2.358-1.651 0-1.026-.853-1.596-2.389-1.596z'
      "
    />
  </svg>
  <svg
    v-if="type === 'divider'"
    :class="className"
    :height="height"
    :width="width"
    viewBox="0 0 128 128"
  >
    <path :fill="fill" d="M0 57.58h128v7.894H0z" />
  </svg>
  <svg
    v-if="type === 'heading'"
    :class="className"
    :height="height"
    :width="width"
    viewBox="0 0 128 128"
  >
    <path
      :fill="fill"
      d="M9.578 24.782h16.001V100H9.578zm42.668 0h16V100h-16zm48.001 0h16.001V100h-16.001z"
    />
    <path
      :fill="fill"
      :d="
        'M20.245 54.87h37.334v15.043H20.245zm80.002-10.03l-16 '
        +'10.03h-5.334V39.825l21.334-15.043h2.667V44.84z'
      "
    />
  </svg>
  <svg
    v-if="type === 'image'"
    :class="className"
    :height="height"
    :width="width"
    viewBox="0 0 128 128"
  >
    <path fill="#A6C8D9" d="M108.8 31.201H19.2v61.766h89.6V31.201z" />
    <path
      fill="#9AB1BD"
      :d="
        'M108.8 92.967V45.603a13.275 13.275 0 00-3.2-.365c-1.28 '
        +'0-2.527.225-3.712.534a13.19 13.19 0 '
        +'00-2.911-1.937c-1.825-.899-3.937-1.404-6.177-1.404-2.273 '
        +'0-4.383.505-6.208 1.432a12.294 12.294 0 00-4.737 4.071 13.828 '
        +'13.828 0 00-8.255-2.696c-1.599 '
        +'0-3.105.281-4.513.759-2.078-3.763-6.399-6.373-11.488-6.373-4.671 '
        +'0-8.736 2.218-10.944 5.502a13.83 13.83 0 00-8.255-2.695c-2.209 '
        +'0-4.255.533-6.081 1.404-2.336-2.555-5.887-4.211-9.919-4.211-1.121 '
        +'0-2.176.111-3.2.364v52.979h89.6z'
      "
    />
    <path
      fill="#738690"
      :d="
        'M108.8 92.967H19.2V57.452c1.439-.646 3.072-.984 4.8-.984 1.377 0 '
        +'2.719.226 3.937.647.927.308 1.759.701 2.558 1.207 0 0 .896.813 '
        +'2.209 1.853 1.183-2.921 3.904-5.222 7.296-6.12a13.174 13.174 0 '
        +'013.2-.393c3.775 0 7.104 1.656 9.119 4.21 1.536-.898 3.33-1.404 '
        +'5.28-1.404 1.314 0 2.53.226 3.649.647 2.337-2.134 5.535-3.453 '
        +'9.152-3.453 4.447 0 8.351 1.993 10.624 4.996 1.92-1.376 '
        +'4.321-2.19 6.976-2.19 3.136 0 5.952 1.124 7.999 2.949.513-.056 '
        +'1.056-.14 1.601-.14 1.505 0 2.944.28 4.257.729 1.726-1.797 '
        +'4.158-3.089 6.943-3.425v36.386z'
      "
    />
    <path
      fill="#39606a"
      d="M108.8 92.967h-32l18.849-23.64c1.726-2.162 5.374-2.162 7.104 0l6.047 7.581v16.059z"
    />
    <path
      fill="#284841"
      d="M97.28 92.967H43.52l23.329-29.254c1.728-2.162 5.374-2.162 7.102 0L97.28 92.967z"
    />
    <path
      fill="#4F6C82"
      d="M71.041 92.967H19.2V68.092l12.449-15.611c1.726-2.161 5.374-2.161 7.104 0l32.288 40.486z"
    />
    <path
      fill="#FFDC2B"
      :d="
        'M93.625 39.624c-4.293 0-6.975 4.679-4.83 8.421a5.567 5.567 0 004.83 2.809c4.294 '
        +'0 6.976-4.68 4.83-8.423a5.566 5.566 0 00-4.83-2.807z'
      "
    />
    <path
      :fill="fill"
      :d="
        'M115.2 19.97c3.53 0 6.4 2.519 6.4 5.615v72.998c0 3.096-2.87 5.615-6.4 '
        +'5.615H12.8c-3.53 0-6.4-2.519-6.4-5.615V25.585c0-3.096 2.87-5.615 '
        +'6.4-5.615h102.4m0-5.615H12.8c-7.04 0-12.8 5.054-12.8 11.23v72.998c0 '
        +'6.177 5.76 11.23 12.8 11.23h102.4c7.04 0 12.8-5.053 '
        +'12.8-11.23V25.585c0-6.176-5.76-11.23-12.8-11.23z'
      "
    />
  </svg>
  <svg
    v-if="type === 'spacer'"
    :class="className"
    :height="height"
    :width="width"
    viewBox="0 0 128 128"
  >
    <path
      :fill="fill"
      :d="'M64 14.222L39.111 42.666h17.778v42.668H39.111L64 '
      +'113.778l24.889-28.444H71.111V42.666h17.778z'"
    />
    <path
      fill="#78909c"
      d="M0 128v-14.222h128V128zM0 14.222V0h128v14.222z"
    />
  </svg>
  <svg
    v-if="type === 'text'"
    :class="className"
    :height="height"
    :width="width"
    viewBox="0 0 128 128"
  >
    <path
      :fill="fill"
      :d="
        'M82.2 109.353v-9.096c6.908 0 9.142-1.424 11.873-4.119 1.902-1.869 2.076-2.826 '
        +'2.076-2.844V30.983c-.058-.635 1.792-8.047-13.949-8.047V13.84c25.432 0 23.243 '
        +'16.873 23.248 17.045v62.376c.005.544-.094 4.678-4.775 9.288-4.582 4.513-8.898 '
        +'6.804-18.473 6.804z'
      "
    />
    <path
      :fill="fill"
      :d="
        'M119.398 109.353v-9.096c-6.908 '
        +'0-9.141-1.424-11.873-4.119-1.902-1.869-2.077-2.826-2.077-2.844V30.983c.'
        +'058-.635-1.792-8.047 13.95-8.047V13.84c-25.432 0-23.244 16.873-23.249 '
        +'17.045v62.376c-.004.544.095 4.678 4.776 9.288 4.581 4.513 8.899 6.804 18.473 6.804z'
      "
    />
    <path
      :fill="fill"
      :d="
        'M82.2 57.048h37.198v9.096H82.2zM49.843 87.175H26.698l-4.21 '
        +'13.156H8.1l23.165-67.657h14.102l23.069 67.657H54.048l-4.205-13.156zM30.367 '
        +'75.901h15.808l-7.742-24.366h-.283l-7.783 24.366z'
      "
    />
  </svg>
</template>;
